import { Admin, Login, Resource } from 'react-admin';
import authProvider from './utils/authProvider';
import dataProvider from './utils/dataProvider';
import PhotoLibraryOutlinedIcon from '@material-ui/icons/PhotoLibraryOutlined';
import UserIcon from '@material-ui/icons/Group';
import RedeemIcon from '@material-ui/icons/Redeem';
import FeedbackIcon from '@material-ui/icons/Feedback';
import ProductIcon from '@material-ui/icons/LocalOffer';
import MonetizationOnIcon from '@material-ui/icons/MonetizationOn';
import { Dashboard } from './pages/Dashboard';
import { UserList } from './pages/user/userList';
import { UserEdit } from './pages/user/userEidt';
import { UserCreate } from './pages/user/userCreate';
import { UserShow } from './pages/user/userShow';
import { CouponList } from './pages/coupon/couponList';
import { CouponCreate } from './pages/coupon/couponCreate';
import { CouponShow } from './pages/coupon/couponShow';
import { ProductList } from './pages/product/productList';
import { ProductCreate } from './pages/product/productCreate';
import { ProductEdit } from './pages/product/productEdit';
import { ProductShow } from './pages/product/productShow';
import { FeedbackList } from './pages/feedback/feedbackList';
import { FeedbackShow } from './pages/feedback/feedbackShow';
import { CouponEdit } from './pages/coupon/couponEdit';
import { AdsList } from './pages/ads/adsList';
import { AdsCreate } from './pages/ads/adsCreate';
import { AdsShow } from './pages/ads/adsShow';
import { AdsEdit } from './pages/ads/adsEdit';
import { DailyRewardList } from './pages/dailyRewardList/dailyRewardList';
import { DailyRewardEdit } from './pages/dailyRewardList/dailyRewardEdit';

const MyLoginPage = () => (
  <Login
    // A random image that changes everyday
    backgroundImage="https://source.unsplash.com/random/1600x900"
    title="Becase Admin"
  />
);

const App = () => {
  return (
    <Admin
      authProvider={authProvider}
      dataProvider={dataProvider}
      dashboard={Dashboard}
      loginPage={MyLoginPage}
    >
      <Resource
        name="users"
        icon={UserIcon}
        list={UserList}
        edit={UserEdit}
        create={UserCreate}
        show={UserShow}
      />
      <Resource
        name="products"
        icon={ProductIcon}
        list={ProductList}
        create={ProductCreate}
        edit={ProductEdit}
        show={ProductShow}
      />
      <Resource
        name="coupons"
        icon={RedeemIcon}
        list={CouponList}
        create={CouponCreate}
        show={CouponShow}
        edit={CouponEdit}
      />
      <Resource
        name="feedbacks"
        icon={FeedbackIcon}
        list={FeedbackList}
        show={FeedbackShow}
      />
      <Resource
        name="ads"
        icon={PhotoLibraryOutlinedIcon}
        list={AdsList}
        create={AdsCreate}
        show={AdsShow}
        edit={AdsEdit}
      />
      <Resource
        name="daily-rewards"
        icon={MonetizationOnIcon}
        list={DailyRewardList}
        edit={DailyRewardEdit}
      />
    </Admin>
  );
};

export default App;
